import { QueryStatus } from '@reduxjs/toolkit/query';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { setConceptGroups } from '@verantos-dev/app-state-cohort-builder';
import { useCohortDefinitionStore } from '@verantos-dev/app-state-cohort-definition';
import type { LegacyConceptGroup } from '@verantos-dev/types-concepts';

import { useGetConceptGroupsQuery } from './conceptGroupsApiSlice';

export const useConceptGroups = () => {
  const dispatch = useAppDispatch();
  const { projectId } = useParams();

  const [isConceptGroupsLoading, setIsConceptGroupsLoading] = useState(false);

  const {
    data: conceptGroupsResponse,
    error: conceptGroupsError,
    refetch: refetchConceptGroups,
    isLoading,
    isFetching,
    isUninitialized,
    status,
  } = useGetConceptGroupsQuery({
    urlParams: projectId ? `projectId=${projectId}` : '',
  });

  useEffect(() => {
    if (conceptGroupsResponse) {
      dispatch(setConceptGroups(conceptGroupsResponse.data));
      useCohortDefinitionStore
        .getState()
        .setConceptGroups(conceptGroupsResponse.data as LegacyConceptGroup[]);
    }
  }, [conceptGroupsResponse, dispatch]);

  // manage refetch loading status
  useEffect(() => {
    if (isUninitialized || isFetching || isLoading) {
      setIsConceptGroupsLoading(true);
    } else if ([QueryStatus.pending, QueryStatus.uninitialized].includes(status)) {
      setIsConceptGroupsLoading(true);
    } else {
      setIsConceptGroupsLoading(false);
    }
  }, [isFetching, isLoading, isUninitialized, status]);

  return {
    conceptGroups: conceptGroupsResponse?.data || [],
    conceptGroupsError,
    refetchConceptGroups,
    isConceptGroupsLoading,
  };
};
